export default "__VITE_ASSET__ca185b50__"